import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDeviceManufacturersStore = defineStore('deviceManufacturers', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getDeviceManufacturers: (state) => state.data?.data,
    getDeviceManufacturerOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexDeviceManufacturerOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'device_manufacturers', ['id','name','company_id']);
          const response = await axios.get('device-manufacturers', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexDeviceManufacturers(params = {}) {
      try {
        const response = await axios.get('device-manufacturers', {params} );
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createDeviceManufacturer(params = {}) {
      try {
        const response = await axios.get('device-manufacturers/create', {params} );
        return useCreateForm('device-manufacturers', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showDeviceManufacturer( deviceManufacturerId, params = {}) {
      try {
        const response = await axios.get(`device-manufacturers/${deviceManufacturerId}`, {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editDeviceManufacturer( deviceManufacturerId, params = {}) {
      try {
        const response = await axios.get(`device-manufacturers/${deviceManufacturerId}/edit`, {params} );
        return useEditForm(`device-manufacturers/${deviceManufacturerId}`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteDeviceManufacturer( deviceManufacturerId, params = {}) {
      try {
        const response = await axios.delete(`device-manufacturers/${deviceManufacturerId}`, {params} );
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Device Manufacturer Deleted',
          detail: `Device Manufacturer has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
